module.exports = __webpack_public_path__ + "img/05.1002da74.jpg";